import { render } from "./ForgottenPasswordView.vue?vue&type=template&id=1b54f11d&ts=true"
import script from "./ForgottenPasswordView.vue?vue&type=script&lang=ts"
export * from "./ForgottenPasswordView.vue?vue&type=script&lang=ts"

import "./ForgottenPasswordView.vue?vue&type=style&index=0&id=1b54f11d&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__